<template>
  <ul style="padding-inline-start: 0 !important">
    <li
      v-for="(element, index) in items"
      :key="index"
      class="d-flex justify-content-between align-items-center SisrCardOption"
    >
      <span
        :class="`d-flex align-items-center ${
          element.button || element.checkbox ? 'w-50' : ''
        }`"
      >
        <span
          v-if="element.details"
          class="mr-2 SisrDetailLabel font-weight-bold text-white"
          @click="detailClicked(element.details)"
          >{{ element.details.buttonLabel }}</span
        >
        <font-awesome-icon
          v-if="element.icon"
          :icon="element.icon"
          class="mr-2"
        />
        <span class="d-flex flex-column SisrLabel">
          <span
            v-for="(label, index) in element.label"
            :key="index"
            :class="`${label.customClass ? label.customClass : ''}`"
            >{{ label.text }}</span
          >
        </span>
      </span>
      <button
        v-if="element.button"
        @click="itemButton.action(element)"
        class="btn btn-primary"
      >
        <span>
          <font-awesome-icon
            v-if="itemButton.icon"
            :icon="itemButton.icon(element)"
            class="mr-2"
          />
          {{ itemButton.label(element) }}
        </span>
      </button>

      <button
        v-if="element.checkbox"
        :class="`btn btn-primary d-flex text-center align-items-center  checkbox ${
          element.selezionato ? 'selected' : 'notSelected'
        }`"
        :disabled="element.obbligatorio"
        :title="element.obbligatorio ? itemCheckbox.requiredHelp : null"
        @click="changeCheckbox(element)"
      >
        <div class="icons mr-1">
          <font-awesome-icon icon="check" class="primary-icon" />
          <span class="secondary-icon">
            <font-awesome-icon icon="hand-pointer" />
          </span>
        </div>
        {{
          element.obbligatorio
            ? itemCheckbox.requiredLabel
            : element.selezionato
              ? itemCheckbox.selectedLabel
              : itemCheckbox.notSelectedLabel
        }}
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    itemButton: {
      type: Object,
      default: null,
    },
    itemCheckbox: {
      type: Object,
      default: null,
    },
  },
  methods: {
    changeCheckbox: function (element) {
      this.$emit("checkboxChange", element);
    },
    detailClicked: function (details) {
      this.$emit("detailClicked", details);
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  display: block;
  transition:
    background-color 0.25s ease-in-out,
    border-color 0.25s ease-in-out,
    width 25s ease-in-out !important;
  &:focus {
    box-shadow: none;
  }
  .icons {
    position: relative;
    .primary-icon {
      transition: 0.25s all;
      transform: rotate(0deg);
      opacity: 1;
    }
    .secondary-icon {
      position: absolute;
      left: 0;
      transition: 0.25s all;
      transform: rotate(-180deg);
      opacity: 0;
    }
  }
}

.checkbox.notSelected {
  background: transparent !important;
  .icons {
    .primary-icon {
      transform: rotate(180deg);
      opacity: 0;
    }
    .secondary-icon {
      transform: rotate(0deg);
      opacity: 1;
    }
  }
}
</style>
